import appReducer from './appReducer'
import metaDataReducer from './metaDataReducer'
import authenticationReducer from './apiReducers/authenticationReducer'
import registerReducer from './apiReducers/registerReducer'
import stateProvinceListReducer from './apiReducers/stateProvinceListReducer'
import { combineReducers } from 'redux'

const rootReducer = combineReducers({
  app: appReducer,
  metaData: metaDataReducer,
  authentication: authenticationReducer,
  register: registerReducer,
  stateProvince: stateProvinceListReducer
})

export default rootReducer
